module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1036-60c1d5af06ea6735be1c7c2ff1a8a631.png";